"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgUser02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.418 18.303C5.391 15.692 8.498 14 12 14c3.501 0 6.609 1.692 8.582 4.303l.027.036c.17.224.351.465.481.697.157.28.274.605.267 1a2.022 2.022 0 0 1-.219.85c-.117.235-.296.491-.546.687-.333.262-.696.355-1.019.393a8.472 8.472 0 0 1-.955.034H5.382c-.337 0-.673 0-.955-.034-.323-.038-.686-.131-1.019-.393a2.023 2.023 0 0 1-.546-.687 2.022 2.022 0 0 1-.219-.85 1.93 1.93 0 0 1 .267-1c.13-.233.312-.473.481-.697l.027-.036ZM6.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z", fill: "currentColor" }) }))); };
exports.default = SvgUser02;
